<div class="table-container">
  @if (config.title) {
    <h3 class="table-title">{{ config.title }}</h3>
  }

  @if (loading) {
    <caixa-webcomponent-shimmer
      width="100%"
      height="40px"
      borderRadius="4px"
      [lines]="shimmerRows"
      marginBottom="5px"
    />
  } @else {
    <div class="table-wrapper">
      <table
        cdk-table
        [dataSource]="data"
        [trackBy]="trackByRow"
        #cdkTable
        class="investments-table"
        [class.table-plain-rows]="config.rowStyle === 'plain'"
      >
        @for (column of config.columns; track column.key) {
          <ng-container [cdkColumnDef]="column.key">
            <th
              *cdkHeaderCellDef
              cdk-header-cell
              class="table-header"
              [class.sortable]="column.sortable"
              [style.width]="column.width"
              (click)="column.sortable ? onSort(column) : null"
            >
              <div [class]="getHeaderContentClass(column)">
                <span class="header-label">
                  {{ column.label }}
                  @if (column.tooltip) {
                    <i
                      class="cds-icon-filled-question c-icon-strong"
                      [cdsTooltip]="column.tooltip"
                      placement="top">
                    </i>
                  }
                </span>
                @if (column.sortable) {
                  <i [class]="getSortIconClass(column)"></i>
                }
              </div>
            </th>

            <td
              *cdkCellDef="let row"
              cdk-cell
              class="table-cell"
              [class]="getColumnClass(column)"
            >
              <ng-container
                [ngTemplateOutlet]="getCellTemplate(column.renderType || 'default')"
                [ngTemplateOutletContext]="getTemplateContext(column, row)"
              />
            </td>
          </ng-container>
        }

        @if (config.showActions && actions.length > 0) {
          <ng-container cdkColumnDef="actions">
            <th
              *cdkHeaderCellDef
              cdk-header-cell
              class="table-header actions-header"
              [style.width]="config.actionsColumnWidth || '120px'"
            ></th>
            <td
              *cdkCellDef="let row"
              cdk-cell
              class="table-cell actions-cell"
            >
              <div class="actions-content">
                @for (action of actions; track action.label) {
                  <button
                    class="action-button"
                    [class]="'action-' + (action.variant || 'outline') + ' action-' + (action.size || 'sm')"
                    (click)="onActionClick(action, row, $event)"
                    [title]="action.label"
                  >
                    <i [class]="action.icon"></i>
                    @if (action.showLabel !== false) {
                      <span class="action-label">{{ action.label }}</span>
                    }
                  </button>
                }
              </div>
            </td>
          </ng-container>
        }

        <tr
          *cdkHeaderRowDef="displayedColumns"
          cdk-header-row
          class="table-header-row"
        ></tr>

        <tr
          *cdkRowDef="let row; columns: displayedColumns"
          cdk-row
          class="table-row"
          (click)="onRowClick(row)"
        ></tr>
      </table>

      @if (data.length === 0) {
        <caixa-webcomponent-empty-state
          [message]="config.emptyMessage || 'Nenhum dado encontrado'"
        />
      }
    </div>
  }
</div>

<ng-template
  #logoTemplate
  let-color="color"
  let-text="text"
  let-tooltip="tooltip"
  let-imageUrl="imageUrl"
  let-bankCode="bankCode"
>
  <div class="logo-cell">
    <div
        class="logo-circle"
      [style.background-color]="color"
      [cdsTooltip]="tooltip !== '-' ? tooltip : text"
      placement="top"
    >
      @if (bankCode) {
        <img
          class="logo-image"
          [src]="resolveLogoUrl(bankCode)"
          [alt]="tooltip !== '-' ? tooltip : text"
          (error)="handleLogoError($event, color, text)"
        />
      } @else if (imageUrl) {
        <img
          class="logo-image"
          [src]="imageUrl"
          [alt]="tooltip !== '-' ? tooltip : text"
          (error)="handleLogoError($event, color, text)"
        />
      } @else {
        <span class="logo-text">{{ text }}</span>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #currencyTemplate
  let-value="value"
  let-class="class"
>
  <span
    class="currency-value"
    [class]="class"
  >
    {{ value }}
  </span>
</ng-template>

<ng-template
  #statusTemplate
  let-text="text"
  let-class="class"
  let-icon="icon"
>
  <div class="status-content">
    <span
      class="status-text"
      [class]="class"
    >
      {{ text }}
    </span>
    @if (icon) {
      <i [class]="icon + ' cds-icon-sm text-muted'"></i>
    }
  </div>
</ng-template>

<ng-template
  #customTemplate
  let-content="content"
  let-row="row"
  let-columnKey="columnKey"
  let-layout="layout"
>
  <span
    class="custom-cell-content"
    [class.custom-cell-content-between]="layout === 'between'"
    [innerHTML]="sanitizeContent(content)"
    (click)="onCustomCellClick($event, columnKey, row)"
  ></span>
</ng-template>

<ng-template
  #defaultTemplate
  let-text="text"
  let-class="class"
  let-icon="icon"
>
  @if (class) {
    <span [class]="class">
      @if (icon) {
        <i [class]="icon + ' cds-icon-sm'"></i>
      }
      {{ text }}
    </span>
  } @else {
    @if (icon) {
      <i [class]="icon + ' cds-icon-sm'"></i>
    }
    {{ text }}
  }
</ng-template>
